import * as actionTypes from "./actionTypes";

export const onPOSTTheTrades = (param, routeToCall, callback = () => {}) => {
  return {
    param,
    routeToCall,
    type: actionTypes.TRADE_POST,
    callback,
  };
};


export const onGETTheTrades = (routeToCall, callback = () => {}) => {
  return {
    routeToCall,
    type: actionTypes.TRADE_GET,
    callback,
  };
};

